<template>
  <div class="dados">
    <div class="row m-0">
      <div class="col-12">
        <h1 class="font-weight-bold text-uppercase">Meus Dados</h1>
        <hr class="linha-amarela" />
        <h4 class="text-uppercase">Dados de Acesso</h4>
        <table class="info">
          <tr>
            <th class="titulo">E-mail:</th>
            <td class="texto" v-if="dados.email.show === false">
              {{ dadosUsuario.email }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.email.show = !dados.email.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.email.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.email.value"
                :placeholder="dados.email.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.email.show = !dados.email.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">Senha:</th>
            <td class="texto" v-if="dados.senha.show === false">
              ********
              <b
                class="btn-modificar letter-orange"
                @click="dados.senha.show = !dados.senha.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.senha.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.senha.value"
                placeholder="******"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.senha.show = !dados.senha.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
        </table>

        <hr class="linha-cinza" />
        <h4 class="text-uppercase">Dados da Conta</h4>
        <table class="info">
          <tr>
            <th class="titulo">Nome:</th>
            <td class="texto" v-if="dados.nome.show === false">
              {{ dadosUsuario.informacoes.nome }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.nome.show = !dados.nome.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.nome.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.nome.value"
                :placeholder="dados.nome.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.nome.show = !dados.nome.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">RG:</th>
            <td class="texto" v-if="dados.rg.show === false">
              {{ dadosUsuario.rg }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.rg.show = !dados.rg.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.rg.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.rg.value"
                :placeholder="dados.rg.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.rg.show = !dados.rg.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">CPF:</th>
            <td class="texto" v-if="dados.cpf.show === false">
              {{ dadosUsuario.cpf }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.cpf.show = !dados.cpf.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.cpf.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.cpf.value"
                :placeholder="dados.cpf.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.cpf.show = !dados.cpf.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">CNPJ:</th>
            <td class="texto" v-if="dados.cnpj.show === false">
              {{ dadosUsuario.cnpj }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.cnpj.show = !dados.cnpj.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.cnpj.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.cnpj.value"
                :placeholder="dados.cnpj.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.cnpj.show = !dados.cnpj.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">Whatsapp:</th>
            <td class="texto" v-if="dados.celular.show === false">
              {{ dadosUsuario.informacoes.celular }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.celular.show = !dados.celular.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.celular.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.celular.value"
                :placeholder="dados.celular.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.celular.show = !dados.celular.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
          <tr>
            <th class="titulo">Telefone:</th>
            <td class="texto" v-if="dados.telefone.show === false">
              {{ dadosUsuario.informacoes.telefone }}
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone.show = !dados.telefone.show"
                ><a class="pointer">Editar</a></b
              >
            </td>
            <td class="texto" v-if="dados.telefone.show === true">
              <input
                type="text"
                class="edit-text"
                v-model="dados.telefone.value"
                :placeholder="dados.telefone.placeholder"
              />
              <b
                class="btn-modificar letter-orange"
                @click="dados.telefone.show = !dados.telefone.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
        </table>

        <hr class="linha-cinza" />
        <h4 class="text-uppercase">Endereço</h4>
        <table class="info">
          <tr>
            <td class="texto">
              <span v-if="dados.endereco.show === false">{{
                dadosUsuario.informacoes.endereco
              }}</span
              ><span v-else
                ><input
                  type="text"
                  v-model="dados.endereco.value"
                  class="d-inline-block w-150px edit-text"
                  :placeholder="dadosUsuario.informacoes.endereco" /></span
              >,
              <span v-if="dados.numero.show === false">{{
                dadosUsuario.informacoes.numero
              }}</span
              ><span v-else
                ><input
                  type="text"
                  v-model="dados.numero.value"
                  class="d-inline-block w-50px edit-text"
                  :placeholder="dadosUsuario.informacoes.numero"
              /></span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.modificarEndNumShow !== true"
                @click="modificarEndNum()"
                ><a class="pointer">Editar</a></b
              ><b
                class="btn-modificar letter-orange"
                v-else
                @click="modificarEndNum()"
                ><a class="pointer">Voltar</a></b
              ><br />
              <span v-if="dados.bairro.show === false">{{
                dadosUsuario.informacoes.bairro
              }}</span
              ><span v-else
                ><input
                  type="text"
                  v-model="dados.bairro.value"
                  class="d-inline-block w-100 edit-text"
                  :placeholder="dadosUsuario.informacoes.bairro"
              /></span>
              -
              <span v-if="dados.cidade.show === false">{{
                dadosUsuario.informacoes.cidade.nome
              }}</span
              ><span v-else
                ><v-select
                  class="d-inline-block"
                  v-model="dados.cidade.value"
                  label="nome"
                  :options="cidades"
                  :placeholder="dadosUsuario.informacoes.cidade.nome"
                ></v-select
              ></span>
              /<span v-if="dados.estado.show === false">{{
                dadosUsuario.informacoes.estado.uf
              }}</span
              ><span v-else>
                <v-select
                  class="d-inline-block"
                  v-model="dados.estado.value"
                  label="uf"
                  :options="estados"
                  :placeholder="dadosUsuario.informacoes.estado.uf"
                ></v-select
              ></span>
              <b
                class="btn-modificar letter-orange"
                v-if="dados.modificarBaiCidEstShow !== true"
                @click="modificarBaiCidEst()"
                ><a class="pointer">Editar</a></b
              ><b
                class="btn-modificar letter-orange"
                v-else
                @click="modificarBaiCidEst()"
                ><a class="pointer">Voltar</a></b
              ><br />
              <span v-if="dados.cep.show === false"
                >CEP: {{ dadosUsuario.informacoes.cep }}</span
              ><span v-else
                ><input
                  type="text"
                  v-model="dados.cep.value"
                  class="d-inline-block w-100px edit-text"
                  :placeholder="dadosUsuario.informacoes.cep" /></span
              ><b
                class="btn-modificar letter-orange"
                v-if="dados.cep.show !== true"
                @click="dados.cep.show = !dados.cep.show"
                ><a class="pointer">Editar</a></b
              >
              <b
                class="btn-modificar letter-orange"
                v-else
                @click="dados.cep.show = !dados.cep.show"
                ><a class="pointer">Voltar</a></b
              >
            </td>
          </tr>
        </table>
        <div class="field-atualizar text-right m-b-30">
          <div
            class="btn btn-success"
            v-if="verificaEdicao()"
            @click="editarAdministrador()"
          >
            Salvar
          </div>
        </div>

        <hr class="linha-cinza" />
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapState, mapGetters } from 'vuex';
import { CoolSelect } from 'vue-cool-select';

export default {
  name: 'dados',
  data: () => ({
    dados: {
      email: {
        value: null,
        placeholder: null,
        show: false,
      },
      senha: {
        value: null,
        placeholder: null,
        show: false,
      },
      nome: {
        value: null,
        placeholder: null,
        show: false,
      },
      rg: {
        value: null,
        placeholder: null,
        show: false,
      },
      cpf: {
        value: null,
        placeholder: null,
        show: false,
      },
      cnpj: {
        value: null,
        placeholder: null,
        show: false,
      },
      celular: {
        value: null,
        placeholder: null,
        show: false,
      },
      telefone: {
        value: null,
        placeholder: null,
        show: false,
      },
      endereco: {
        value: null,
        placeholder: null,
        show: false,
      },
      numero: {
        value: null,
        placeholder: null,
        show: false,
      },
      bairro: {
        value: null,
        placeholder: null,
        show: false,
      },
      cidade: {
        value: null,
        placeholder: null,
        show: false,
      },
      estado: {
        value: null,
        placeholder: null,
        show: false,
      },
      cep: {
        value: null,
        placeholder: null,
        show: false,
      },
      modificarEndNumShow: false,
      modificarBaiCidEstShow: false,
    },
  }),
  components: {
    CoolSelect,
  },
  computed: {
    ...mapState(['token', 'dadosUsuario', 'estados', 'cidades']),
    ...mapGetters(['getTipoNotification', 'getNotification']),
  },
  created() {
    this.$store.dispatch('loadCidades');
    this.$store.dispatch('loadEstados');
  },
  beforeMount() {
    if (this.checkIsEmpty(this.token)) {
      this.$router.push({ name: 'area-restrita' });
    }
    this.dados.email.placeholder = this.dadosUsuario.email;
    this.dados.nome.placeholder = this.dadosUsuario.informacoes.nome;
    this.dados.rg.placeholder = this.dadosUsuario.rg;
    this.dados.cpf.placeholder = this.dadosUsuario.cpf;
    this.dados.cnpj.placeholder = this.dadosUsuario.cnpj;
    this.dados.celular.placeholder = this.dadosUsuario.informacoes.celular;
    this.dados.telefone.placeholder = this.dadosUsuario.informacoes.telefone;
    this.dados.endereco.placeholder = this.dadosUsuario.informacoes.endereco;
    this.dados.numero.placeholder = this.dadosUsuario.informacoes.numero;
    this.dados.bairro.placeholder = this.dadosUsuario.informacoes.bairro;
    this.dados.cidade.placeholder = this.dadosUsuario.informacoes.cidade;
    this.dados.estado.placeholder = this.dadosUsuario.informacoes.estado;
    this.dados.cep.placeholder = this.dadosUsuario.informacoes.cep;
  },
  beforeUpdate() {
    if (this.$router.history.current.name === 'cadastro') {
      if (this.checkIsEmpty(this.token)) {
        this.$router.push({ name: 'area-restrita' });
      }
    }
  },
  methods: {
    checkIsEmpty(value) {
      if (
        value === '' ||
        value === null ||
        value === 'null' ||
        value === 'undefined'
      ) {
        return true;
      }
      return false;
    },
    aviso(texto, tipo) {
      this.$bvToast.toast(texto, {
        title: 'Aviso',
        variant: tipo,
        autoHideDelay: 5000,
        appendToast: true,
      });
    },
    modificarEndNum() {
      this.dados.endereco.show = !this.dados.endereco.show;
      this.dados.numero.show = !this.dados.numero.show;
      this.dados.modificarEndNumShow = !this.dados.modificarEndNumShow;
    },
    modificarBaiCidEst() {
      this.dados.bairro.show = !this.dados.bairro.show;
      this.dados.cidade.show = !this.dados.cidade.show;
      this.dados.estado.show = !this.dados.estado.show;
      this.dados.modificarBaiCidEstShow = !this.dados.modificarBaiCidEstShow;
    },
    verificaEdicao() {
      if (
        this.dados.email.show !== false ||
        this.dados.nome.show !== false ||
        this.dados.rg.show !== false ||
        this.dados.cpf.show !== false ||
        this.dados.cnpj.show !== false ||
        this.dados.celular.show !== false ||
        this.dados.telefone.show !== false ||
        this.dados.endereco.show !== false ||
        this.dados.numero.show !== false ||
        this.dados.bairro.show !== false ||
        this.dados.cidade.show !== false ||
        this.dados.estado.show !== false ||
        this.dados.cep.show !== false ||
        this.dados.senha.show !== false
      ) {
        return true;
      }
      return false;
    },
    editarAdministrador() {
      const self = this;
      const data = {
        id: this.dadosUsuario.id,
        id_administrador: this.dadosUsuario.informacoes.id,
        email: this.dados.email.value,
        nome: this.dados.nome.value,
        rg: this.dados.rg.value,
        cpf: this.dados.cpf.value,
        cnpj: this.dados.cnpj.value,
        celular: this.dados.celular.value,
        telefone: this.dados.telefone.value,
        endereco: this.dados.endereco.value,
        numero: this.dados.numero.value,
        bairro: this.dados.bairro.value,
        cidade: this.dados.cidade.value,
        estado: this.dados.estado.value,
        cep: this.dados.cep.value,
        password: this.dados.senha.value,
      };

      this.$store.dispatch('updateAdministrador', data).then((data) => {
        this.$store.dispatch('startLoader');
        setTimeout(() => {
          if (this.getTipoNotification == 1) {
            this.aviso(this.getNotification, 'success');
            self.dados.email.show = false;
            self.dados.nome.show = false;
            self.dados.rg.show = false;
            self.dados.cpf.show = false;
            self.dados.cnpj.show = false;
            self.dados.celular.show = false;
            self.dados.telefone.show = false;
            self.dados.endereco.show = false;
            self.dados.numero.show = false;
            self.dados.bairro.show = false;
            self.dados.cidade.show = false;
            self.dados.estado.show = false;
            self.dados.cep.show = false;
            self.dados.senha.show = false;
          } else if (this.getTipoNotification == 3) {
            this.aviso(this.getNotification, 'danger');
          }
        }, 1000);
      });
    },
  },
};
</script>
